import { useState, useRef, useEffect } from "react";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { CircularProgress } from '@material-ui/core';
import { useDispatch } from "react-redux";
import { handleSnackBar, invokePostService, generateLlmComponents, setLlmQuery } from "../../../store/global/actions";
import Tooltip from '@material-ui/core/Tooltip';

function QueryLauncher() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const textareaRef = useRef(null);

  const dispatch = useDispatch()


  // auto resize textarea on input
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
    }
  }, [query, open]);
  

const handleSubmitQuery  = async () => {

    if (!query.trim()) return;
    setLoading(true);
    dispatch(setLlmQuery(query))
    try {
      dispatch(invokePostService('llmGenerateComponents', {prompt:query, system_model_flows:[] }, []))
        .then((response) => {
          if (response.status) {
            dispatch(generateLlmComponents({ status : response.status, data: response }));
          } else {
            dispatch(generateLlmComponents({ status : false, data: null }));
            dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
          }
          setLoading(false);

        })
        .catch((error) => {
          console.error(error)
          setLoading(false);
        });
    } catch (err) {
      console.error("Error submitting query", err);
    } finally {
    }

  }

  return (
    <div
      style={{
        position: "absolute",
        top: "100px",
        left: "40px",
        display: "flex",
        alignItems: "flex-start",
        gap: "8px",
        zIndex: 1200,
      }}
      id="generate_llm_icon"
    >
      {/* Main Circle Icon */}
      <Tooltip title={open ? "Close the Prompt" : "Try AI"} arrow>
        <div
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#48566a",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            flexShrink: 0,
            position: "relative",
          }}
          onClick={() => setOpen((prev) => !prev)}
        >
          <img
            src={`${process.env.PUBLIC_URL}/node_icons/ai.png`}
            alt="AI Node"
            style={{ width: "28px", height: "28px", objectFit: "contain" }}
          />
        </div>
      </Tooltip>

      {/* Query Input Box */}
      {open && (
        <div
        style={{
          position: "relative",
          border: "1px solid #ccc",
          borderRadius: "25px",
          padding: "6px 10px",
          paddingRight: '6px',
          backgroundColor: "#fff",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
          width: "500px",
          maxWidth: "600px",
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
        id="llm_query_input"
      >
        <textarea
          ref={textareaRef}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Design IoT app for fleet tracking"
          rows={1}
          style={{
            border: "none",
            outline: "none",
            fontSize: "14px",
            width: "100%",
            resize: "none",
            overflow: "hidden",
            flex: 1,
            boxSizing: "border-box",
            alignSelf: 'center'
          }}
          id="query_text_area"
        />
      
        {/* Generate Button */}
          <Tooltip title="Generate components" arrow>
            <button
              style={{
                // position: "absolute",
                // right: "8px", // ✅ sits flush with right border
                // top:
                //   textareaRef.current && textareaRef.current.scrollHeight > 28
                //     ? "auto"
                //     : "50%", // center for 1 line
                // bottom:
                //   textareaRef.current && textareaRef.current.scrollHeight > 28
                //     ? "8px"
                //     : "auto", // stick to bottom when multi-line
                // transform:
                //   textareaRef.current && textareaRef.current.scrollHeight > 28
                //     ? "none"
                //     : "translateY(-50%)", // true vertical centering for 1 line
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "#48566a",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              id="query_generate_button"
              onClick={handleSubmitQuery}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={18} style={{ color: "#fff" }} />
              ) : (
                <ArrowUpwardIcon style={{ fontSize: 18 }} />
              )}
            </button>
          </Tooltip>
      </div>
      )}
    </div>
  );
}

export default QueryLauncher;
